import { FlashbarProps } from "@cloudscape-design/components-themed";

interface MsgObj {
  level: FlashbarProps.Type;
  label: string;
}

export interface Messages {
  KGRERR001: MsgObj;
  KGRERR002: MsgObj;
  KGRERR003: MsgObj;
  KGRERR004: MsgObj;
  KGRERR005: MsgObj;
  KGRERR006: MsgObj;
  KGRERR007: MsgObj;
  KGRERR008: MsgObj;
  KGRERR009: MsgObj;
  KGRERR010: MsgObj;
  KGRERR011: MsgObj;
  KGRERR012: MsgObj;
  KGRERR013: MsgObj;
  KGRERR014: MsgObj;
  KGRERR015: MsgObj;
  KGRERR017: MsgObj;
  KGRERR021: MsgObj;
  KGRERR022: MsgObj;
  KGRERR023: MsgObj;
  KGRERR024: MsgObj;
  KGRERR025: MsgObj;
  KGRERR026: MsgObj;
  KGRERR027: MsgObj;
  KGRERR028: MsgObj;
  KGRERR029: MsgObj;
  KGRERR030: MsgObj;
  KGRERR031: MsgObj;
  KGRERR032: MsgObj;
  KGRERR033: MsgObj;
  KGRERR037: MsgObj;
  KGRERR038: MsgObj;
  KGRERR039: MsgObj;
  KGRERR040: MsgObj;
  KGRERR041: MsgObj;
  KGRERR042: MsgObj;
  KGRERR043: MsgObj;
  KGRERR044: MsgObj;
  KGRERR045: MsgObj;
  KGRERR046: MsgObj;
  KGRERR047: MsgObj;
  KGRERR048: MsgObj;
  KGRERR049: MsgObj;
  KGRERR050: MsgObj;
  KGRERR051: MsgObj;
  KGRERR052: MsgObj;
  KGRERR053: MsgObj;
  KGRERR054: MsgObj;
  KGRERR055: MsgObj;
  KGRERR056: MsgObj;
  KGRERR057: MsgObj;
  KGRERR058: MsgObj;
  KGRERR059: MsgObj;
  KGRERR060: MsgObj;
  KGRERR061: MsgObj;
  KGRERR062: MsgObj;
  KGRERR064: MsgObj;
  KGRERR065: MsgObj;
  KGRERR066: MsgObj;
  KGRERR067: MsgObj;
  KGRERR069: MsgObj;
  KGRERR070: MsgObj;
  KGRERR073: MsgObj;
  KGRERR079: MsgObj;
  KGRERR083: MsgObj;
  KGRERR085: MsgObj;
  KGRERR086: MsgObj;
  KGRERR087: MsgObj;
  KGRERR088: MsgObj;
  KGRERR089: MsgObj;
  KGRERR097: MsgObj;
  KGRERR098: MsgObj;
  KGRERR101: MsgObj;
  KGRERR102: MsgObj;
  KGRERR103: MsgObj;
  KGRERR111: MsgObj;
  KGRERR112: MsgObj;
  KGRERR113: MsgObj;
  KGRERR114: MsgObj;
  KGRERR115: MsgObj;
  KGRERR116: MsgObj;
  KGRERR117: MsgObj;
  KGRERR118: MsgObj;
  KGRERR119: MsgObj;
  KGRERR120: MsgObj;
  KGRERR121: MsgObj;
  KGRERR122: MsgObj;
  KGRERR123: MsgObj;
  KGRERR124: MsgObj;
  KGRERR125: MsgObj;
  KGRERR126: MsgObj;
  KGRERR127: MsgObj;
  KGRERR128: MsgObj;
  KGRERR129: MsgObj;
  KGRERR130: MsgObj;
  KGRERR131: MsgObj;
  KGRERR132: MsgObj;
  KGRERR133: MsgObj;
  KGRERR134: MsgObj;
  KGRERR135: MsgObj;
  KGRERR136: MsgObj;
  KGRERR138: MsgObj;
  KGRERR139: MsgObj;
  KGRERR140: MsgObj;
  KGRERR141: MsgObj;
  KGRERR142: MsgObj;
  KGRERR143: MsgObj;
  KGRERR144: MsgObj;
  KGRERR145: MsgObj;
  KGRERR146: MsgObj;
  KGRERR147: MsgObj;
  KGRERR148: MsgObj;
  KGRERR149: MsgObj;
  KGRERR150: MsgObj;
  KGRERR151: MsgObj;
  KGRERR152: MsgObj;
  KGRERR154: MsgObj;
  KGRERR155: MsgObj;
  KGRERR156: MsgObj;
  KGRERR157: MsgObj;
  KGRERR158: MsgObj;
  KGRERR159: MsgObj;
  KGRERR160: MsgObj;
  KGRERR161: MsgObj;
  KGRERR162: MsgObj;
  KGRERR163: MsgObj;
  KGRERR164: MsgObj;
  KGRERR165: MsgObj;
  KGRERR166: MsgObj;
  KGRERR167: MsgObj;
  KGRERR168: MsgObj;
  KGRERR169: MsgObj;
  KGRERR170: MsgObj;
  KGRERR171: MsgObj;
  KGRERR172: MsgObj;
  KGRERR174: MsgObj;
  KGRFAT001: MsgObj;
  KGRINF007: MsgObj;
  KGRINF017: MsgObj;
  KGRINF018: MsgObj;
  KGRINF019: MsgObj;
  KGRINF020: MsgObj;
  KGRINF021: MsgObj;
  KGRINF022: MsgObj;
  KGRINF023: MsgObj;
  KGRINF024: MsgObj;
  KGRINF027: MsgObj;
  KGRINF040: MsgObj;
  KGRWAR003: MsgObj;
}

export const messages: Messages = {
  KGRERR001: {
    level: "error",
    label:
      "リクエストでバリデーションエラーが発生しました。システム運用者へお問い合わせください。",
  },
  KGRERR002: {
    level: "error",
    label: "許可されていない操作が行われました。",
  },
  KGRERR003: {
    level: "error",
    label: "競合が発生しました。画面をリフレッシュしてください。",
  },
  KGRERR004: {
    level: "error",
    label: "サービスが利用できません。時間をおいてから再度お試しください。",
  },
  KGRERR005: {
    level: "error",
    label: "検索条件を一つ以上に設定してください。",
  },
  KGRERR006: {
    level: "error",
    label: "数値で入力してください。",
  },
  KGRERR007: {
    level: "error",
    label:
      "データベースエラーです。しばらく待ってから、再度実行してください。事象が改善されない場合はシステム管理者に連絡してください。",
  },
  KGRERR008: {
    level: "error",
    label:
      "ファイル形式またはファイル拡張子が正しくないため開くことができません。",
  },
  KGRERR009: {
    level: "error",
    label: "ファイルが破損している為、開くことができません。",
  },
  KGRERR010: {
    level: "error",
    label: "ファイル行数が最大行数を超えています。（最大行数：{0}行目）",
  },
  KGRERR011: {
    level: "error",
    label:
      "レコードのフォーマットに不備があった為、処理できません。（不備行：{0}行目）",
  },
  KGRERR012: {
    level: "error",
    label: "無効なURLです。",
  },
  KGRERR013: {
    level: "error",
    label:
      "問題が発生しました。システム運用者へお問い合わせください。（メッセージID={0}）",
  },
  KGRERR014: {
    level: "error",
    label: "エラーが発生しました。{0}\\n{1}",
  },
  KGRERR015: {
    level: "error",
    label: "{0}が重複定義されています。（重複行：{1}行目）",
  },
  KGRERR017: {
    level: "error",
    label: "{0}は{1}から{2}文字にしてください。（不備行：{3}行目）",
  },
  KGRERR021: {
    level: "error",
    label: "既にレコードが登録されています。 テーブル名:{0} 登録データ:{1}",
  },
  KGRERR022: {
    level: "error",
    label: "対象のレコードがありません。 テーブル名:{0} 検索条件:{1}",
  },
  KGRERR023: {
    level: "error",
    label: "{0}は必須項目です。",
  },
  KGRERR024: {
    level: "error",
    label: "{0}は{1}文字以内で入力してください。",
  },
  KGRERR025: {
    level: "error",
    label: "Eメールアドレスの形式で入力してください。",
  },
  KGRERR026: {
    level: "error",
    label: "カタカナで入力してください。",
  },
  KGRERR027: {
    level: "error",
    label: "{0}は{1}文字固定で入力してください。",
  },
  KGRERR028: {
    level: "error",
    label: "承認アクションが不正です。承認ステータス:{0}、アクション:{1}",
  },
  KGRERR029: {
    level: "error",
    label: "{0}の場合、{1}が必須です。",
  },
  KGRERR030: {
    level: "error",
    label: "{0}は重複しており、登録出来ません。登録情報を見直してください。",
  },
  KGRERR031: {
    level: "error",
    label: "{0}の入力が不正です。",
  },
  KGRERR032: {
    level: "error",
    label: "{0}には{1}形式で入力してください。",
  },
  KGRERR033: {
    level: "error",
    label: "{0}には{1}形式で入力してください。（不備行：{2}行目）",
  },
  KGRERR037: {
    level: "error",
    label: "メールアドレスまたはパスワードが違います。",
  },
  KGRERR038: {
    level: "error",
    label:
      "アカウントがロックされています。しばらく経ってからログインしてください。",
  },
  KGRERR039: {
    level: "error",
    label: "{0}専用画面です。ご不明点は管理者にお問い合わせください。",
  },
  KGRERR040: {
    level: "error",
    label: "入力されたコードは無効です。ログインをやり直してください。",
  },
  KGRERR041: {
    level: "error",
    label: "入力されたコードは無効です。",
  },
  KGRERR042: {
    level: "error",
    label: "新しいパスワードと新しいパスワード（確認）が一致しません。",
  },
  KGRERR043: {
    level: "error",
    label: "新しいパスワードがパスワードの規則を満たしていません。",
  },
  KGRERR044: {
    level: "error",
    label: "存在しないメールアドレスです。",
  },
  KGRERR045: {
    level: "error",
    label:
      "試行回数の制限を超過しました。しばらく経ってからやり直してください。",
  },
  KGRERR046: {
    level: "error",
    label: "現在のパスワードが間違っています。",
  },
  KGRERR047: {
    level: "error",
    label: "自分自身のアカウントは削除できません。",
  },
  KGRERR048: {
    level: "error",
    label: "{0}は使用中のため削除出来ません。",
  },
  KGRERR049: {
    level: "error",
    label:
      "すでに登録済みのメールアドレスです。アカウント一覧より氏名のリンクをクリックし、アカウント更新をご利用ください。",
  },
  KGRERR050: {
    level: "error",
    label:
      "管理者を全員削除または無効にすることはできません。画面を再表示してください。",
  },
  KGRERR051: {
    level: "error",
    label: "ファイルフォーマットが誤っています。（ファイル名：{0}）",
  },
  KGRERR052: {
    level: "error",
    label: "{0}は必須入力項目です。（不備行：{1}行目）",
  },
  KGRERR053: {
    level: "error",
    label: "{0}の入力が不正です。（不備行：{1}行目）",
  },
  KGRERR054: {
    level: "error",
    label: "ファイルが選択されていません。",
  },
  KGRERR055: {
    level: "error",
    label: "必須項目です。",
  },
  KGRERR056: {
    level: "error",
    label: "該当ユーザは存在しません。",
  },
  KGRERR057: {
    level: "error",
    label:
      "選択されたファイルはExcelファイルではありません。選択ファイルを確認してください。",
  },
  KGRERR058: {
    level: "error",
    label: "{0}文字以内で入力してください。",
  },
  KGRERR059: {
    level: "error",
    label: "{0}桁以内で入力してください。",
  },
  KGRERR060: {
    level: "error",
    label: "入力された{0}に対応する{1}が存在しません。",
  },
  KGRERR061: {
    level: "error",
    label: "更新差分が{0}の場合は{1}は必須項目です。（不備行：{2}行目）",
  },
  KGRERR062: {
    level: "error",
    label:
      "申請処理でエラーが発生しました。ダウンロードされたファイルを確認してください。",
  },
  KGRERR064: {
    level: "error",
    label:
      "店舗店子シートと同時に申請する場合は、{0}は必須です。（不備行：{1}行目）",
  },
  KGRERR065: {
    level: "error",
    label: "{0}{1}桁で入力してください。",
  },
  KGRERR066: {
    level: "error",
    label:
      "{0}は重複しており、登録出来ません。登録情報を見直してください。（{1}）",
  },
  KGRERR067: {
    level: "error",
    label: "{0}は{1}で入力してください。（{2}）",
  },
  KGRERR069: {
    level: "error",
    label: "検証済みなユーザです。",
  },
  KGRERR070: {
    level: "error",
    label:
      "仮パスワードの有効期限が切れています。管理者にお問い合わせの上、再発行してください。",
  },
  KGRERR073: {
    level: "error",
    label: "{0}桁固定で入力してください。",
  },
  KGRERR079: {
    level: "error",
    label: "整数部{0}桁以内、小数部{1}桁以内の値を入力してください。",
  },
  KGRERR083: {
    level: "error",
    label: "{0}のダウンロードに失敗しました",
  },
  KGRERR085: {
    level: "error",
    label:
      "対象の申請が存在しないか当該処理を実行できないステータスのため、処理を中止しました。",
  },
  KGRERR086: {
    level: "error",
    label:
      "選択した審査対象は仕向け先に設定されているため再審査申請できません。",
  },
  KGRERR087: {
    level: "error",
    label: "選択した審査対象は審査待ちのため再審査申請はできません。",
  },
  KGRERR088: {
    level: "error",
    label: "選択した審査対象は審査中のため再審査申請できません。",
  },
  KGRERR089: {
    level: "error",
    label: "再審査対象選定・指示は実行済みです。",
  },
  KGRERR097: {
    level: "error",
    label:
      "選択されたファイルはExcelファイルまたは、CSVファイルではありません。選択ファイルを確認してください。",
  },
  KGRERR098: {
    level: "error",
    label: "選択されたファイルにデータが入力されていません。",
  },
  KGRERR101: {
    level: "error",
    label: "審査OKから審査NGに変更できません。選択ファイルを確認してください。",
  },
  KGRERR102: {
    level: "error",
    label:
      "回答項目：{0}でエラーが発生しました。選択ファイルを確認してください。",
  },
  KGRERR103: {
    level: "error",
    label: "契約パターンが{0}の場合、{1}は必須項目です。（不備行：{2}行目）",
  },
  KGRERR111: {
    level: "error",
    label: "{0}の桁数が誤っています。（不備行：{1}行目）",
  },
  KGRERR112: {
    level: "error",
    label:
      "{0}の文字数が誤っているため、{1}字以内で入力してください。（不備行：{2}行目）",
  },
  KGRERR113: {
    level: "error",
    label: "{0}は都道府県から入力してください。（不備行：{1}行目）",
  },
  KGRERR114: {
    level: "error",
    label: "{0}は{1}で入力してください。（不備行：{2}行目）",
  },
  KGRERR115: {
    level: "error",
    label:
      "{0}は姓と名の間に{1}スペースを入力してください。（不備行：{2}行目）",
  },
  KGRERR116: {
    level: "error",
    label: "{0}は小数点第二位まで入力してください。（不備行：{1}行目）",
  },
  KGRERR117: {
    level: "error",
    label: "{0}は西暦で入力してください。（不備行：{1}行目）",
  },
  KGRERR118: {
    level: "error",
    label: "{0}は未来日は入力できません。（不備行：{1}行目）",
  },
  KGRERR119: {
    level: "error",
    label: "更新差分は必須入力項目です。（不備行：{0}行目）",
  },
  KGRERR120: {
    level: "error",
    label: "{0}は必須入力項目です。（不備行：{1}行目）",
  },
  KGRERR121: {
    level: "error",
    label: "個人事業主の場合、{0}は必須入力項目です。（不備行：{1}行目）",
  },
  KGRERR122: {
    level: "error",
    label: "商業施設の場合、{0}は必須入力項目です。（不備行：{1}行目）",
  },
  KGRERR123: {
    level: "error",
    label: "更新差分：変更では料率変更はできません。（不備行：{0}行目）",
  },
  KGRERR124: {
    level: "error",
    label: "更新差分：変更ではQR提示区分は変更できません。（不備行：{0}行目）",
  },
  KGRERR125: {
    level: "error",
    label: "サイトIDもしくは加盟店管理番号は必須です。（不備行：{0}行目）",
  },
  KGRERR126: {
    level: "error",
    label: "適用日を過ぎていない{0}が存在しています。（不備行：{1}行目）",
  },
  KGRERR127: {
    level: "error",
    label: "このGWは選択できません。（不備行：{0}行目）",
  },
  KGRERR128: {
    level: "error",
    label: "このGWは選択できません。",
  },
  KGRERR129: {
    level: "error",
    label:
      "手数料率が不正です。正しい数値で入力してください。（不備行：{0}行目）",
  },
  KGRERR130: {
    level: "error",
    label: "存在しない{0}です。（不備行：{1}行目）",
  },
  KGRERR131: {
    level: "error",
    label:
      "この番号は既に他のサイトIDに紐づいています。新しい番号を入力してください。（不備行：{0}行目）",
  },
  KGRERR132: {
    level: "error",
    label: "現在申請中の加盟店です。（不備行：{0}行目）",
  },
  KGRERR133: {
    level: "error",
    label: "現在申請中の店舗です。（不備行：{0}行目）",
  },
  KGRERR134: {
    level: "error",
    label: "申請書内に同一の{0}が存在しています。（不備行：{1}行目）",
  },
  KGRERR135: {
    level: "error",
    label: "不備理由：{0} （不備行：{1}行目）",
  },
  KGRERR136: {
    level: "error",
    label:
      "選択された又は紐づく申請事業者のサイトIDではありません。（不備行：{0}行目）",
  },
  KGRERR138: {
    level: "error",
    label: "事業者情報の変更が行われています。",
  },

  KGRERR139: {
    level: "error",
    label:
      "加盟店申請書を複数枚アップロード時はドコモ項目申請書をアップロードできません。",
  },
  KGRERR140: {
    level: "error",
    label: "{0}から{1}に変更できません。（不備行：{2}行目）",
  },
  KGRERR141: {
    level: "error",
    label:
      "現在申請中の{0}か、適用日を過ぎていない{0}が存在しています。（不備行：{1}行目）",
  },
  KGRERR142: {
    level: "error",
    label:
      "申請された{0}に紐付く申請事業者情報が見つかりません。（不備行：{1}行目）",
  },
  KGRERR143: {
    level: "error",
    label: "{0}が重複しています。（不備行：{1}行目）",
  },
  KGRERR144: {
    level: "error",
    label: "ポイント付与区分が「{0}」の場合、{1}（不備行：{2}行目）",
  },
  KGRERR145: {
    level: "error",
    label:
      "選択された決済方法に対応する、与信パターンを選択してください。（不備行：{0}行目）",
  },
  KGRERR146: {
    level: "error",
    label:
      "決済方法が未選択で、該当の与信パターンが未登録です。与信パターンを設定しないで下さい。（不備行：{0}行目）",
  },
  KGRERR147: {
    level: "error",
    label: "現在申請中の申請事業者です。（不備行：{0}行目）",
  },
  KGRERR148: {
    level: "error",
    label: "クレカ審査が未実施の店子が存在します。",
  },
  KGRERR149: {
    level: "error",
    label: "入力されたサイトIDは申請できません。（不備行：{0}行目）",
  },
  KGRERR150: {
    level: "error",
    label: "法人番号と事業者情報が一致しません。（不備行：{0}行目）",
  },
  KGRERR151: {
    level: "error",
    label: "ダウンロード可能な申請がありません。",
  },
  KGRERR152: {
    level: "error",
    label: "更新差分が{0}の場合は{1}の申請はできません。（不備行：{2}行目）",
  },
  KGRERR154: {
    level: "error",
    label: "外部APIから想定外のデータを受信しました。（詳細：{0}）",
  },
  KGRERR155: {
    level: "error",
    label: "{0}と{1}の個数が不一致です。（不備行：{2}行目）",
  },
  KGRERR156: {
    level: "error",
    label: "{0}の場合は{1}は必須項目です。（不備行：{2}行目) ",
  },
  KGRERR157: {
    level: "error",
    label: "申請情報が入力されていません。　",
  },
  KGRERR158: {
    level: "error",
    label: "{0}は指定できません。（不備行：{1}行目）",
  },
  KGRERR159: {
    level: "error",
    label:
      "更新差分が{0}の法人シートと店舗店子シートを同時に申請する場合は、{1}は指定できません。（不備行：{2}行目）",
  },
  KGRERR160: {
    level: "error",
    label: "{0}が特定できません（不備行：{1}行目） ",
  },
  KGRERR161: {
    level: "error",
    label:
      "サイトIDが登録できません。IPIDまたは申請内容を確認してください。（不備行：{0}行目）",
  },
  KGRERR162: {
    level: "error",
    label: "全銀テレ為替文字で入力してください。",
  },
  KGRERR163: {
    level: "error",
    label:
      "代表者生年月日が不正です。正しい生年月日を入力してください。（不備行：{0}行目）",
  },
  KGRERR164: {
    level: "error",
    label: "{0}で入力してください。",
  },
  KGRERR165: {
    level: "error",
    label:
      "ご指定いただいたサイトIDについて進行中の申請があります。完了してから再度ご申請ください。不備行：{0}行目）",
  },
  KGRERR166: {
    level: "error",
    label:
      "解約申請時はドコモ項目のアップロードは不要です。（不備行：{0}行目）",
  },
  KGRERR167: {
    level: "error",
    label: "{0}可能な状態ではありません。（不備行：{1}行目）",
  },
  KGRERR168: {
    level: "error",
    label:
      "前回申請時の{0}とは異なる入力値が指定されています。（不備行：{1}行目）",
  },
  KGRERR169: {
    level: "error",
    label: "{0}が{1}よりも過去日付です。（不備行：{2}行目）",
  },
  KGRERR170: {
    level: "error",
    label: "{0}に「{1}」は使用できません。（不備行：{2}行目）",
  },
  KGRERR171: {
    level: "error",
    label: "既に解約申請受付済みのサイトIDです。（不備行：{0}行目）",
  },
  KGRERR172: {
    level: "error",
    label: "{0}に使用できない記号が含まれています。（不備行：{1}行目）",
  },
  KGRERR174: {
    level: "error",
    label:
      "住所の正規化に失敗しました。都道府県が記載されていません。住所：{0}",
  },
  KGRFAT001: {
    level: "error",
    label:
      "システムエラーが発生しました。時間をおいてから再度試すか、システム運用者へお問い合わせください。",
  },
  KGRINF007: {
    level: "success",
    label: "データが更新されました。",
  },
  KGRINF017: {
    level: "success",
    label: "{0}を一時保存しました。",
  },
  KGRINF018: {
    level: "success",
    label: "{0}を引戻しました。",
  },
  KGRINF019: {
    level: "success",
    label: "{0}を承認依頼しました。",
  },
  KGRINF020: {
    level: "success",
    label: "{0}を差戻しました。",
  },
  KGRINF021: {
    level: "success",
    label: "{0}を承認しました。",
  },
  KGRINF022: {
    level: "success",
    label: "{0}を一時保存削除しました。",
  },
  KGRINF023: {
    level: "success",
    label: "データが登録されました。",
  },
  KGRINF024: {
    level: "success",
    label: "データが削除されました。",
  },
  KGRINF027: {
    level: "success",
    label: "検証コードが送信されました。",
  },
  KGRINF040: {
    level: "success",
    label: "ダウンロードしました。",
  },
  KGRWAR003: {
    level: "error",
    label: "登録件数が最大数を超えています（最大行数：{0}件）",
  },
};

/**
 *
 * @param msgId メッセージID
 * @param msgArgs メッセージ引数
 * @returns メッセージObj
 */
export const getMessage = (
  msgId: keyof Messages,
  ...msgArgs: unknown[]
): MsgObj => {
  let msgLabel: string = messages[msgId].label;

  for (const [i, arg] of msgArgs.entries()) {
    const regExp = new RegExp(`\\{${i}\\}`, "g");
    msgLabel = msgLabel.replace(regExp, arg as string);
  }

  return {
    level: messages[msgId].level,
    label: msgLabel,
  };
};
